import { Col, Container, Row } from 'design-react-kit/dist/design-react-kit';
import HistoricalData from './HistoricalData';

const Body = ({ data, id }) => {
  const historicalConfig = {
    datasetCode: data?.datasetCode,
    filters: data?.filters,
    fromDateProp: data?.fromDateProp,
    toDateProp: data?.toDateProp,
    minDate: data?.minDate,
    maxDate: data?.maxDate,
    maxDays: data?.maxDays,
    requiredFields: data?.requiredFields,
  };

  return (
    <Container>
      <Row className="mr-lg-2">
        <Col lg={8} className="px-0">
          <div className="historicalData">
            <HistoricalData data={historicalConfig} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Body;
